
// import { ValidationProvider } from 'vee-validate';
import { extend, localize } from 'vee-validate';
import { required, email, min } from 'vee-validate/dist/rules';
import en from "vee-validate/dist/locale/en.json";
// import sk from "vee-validate/dist/locale/sk.json";
// import de from "vee-validate/dist/locale/de.json";

extend("required", required);
extend("email", email);
extend("min", min);

localize({
  en: {
    massages: en.messages,
    names: {
      email: "E-mail Address",
      password: "Password"
    }
  },

  sk: {
    massages: en.messages,
    names: {
      email: "E-mail",
      password: "Heslo"
    }
  },

  de: {
    massages: en.messages,
    names: {
      email: "E-mail Adresse",
      password: "Passwort"
    }
  }
})

// extend('required', {
//   ...required,
//   message: 'This field is required'
// });
// extend('email', {
//   ...email,
//   message: 'Enter a valid Email address'
// });

// Vue.component('ValidationProvider', ValidationProvider);
